export const SET_USER = "setUser"
export const SHOW_NOTIFICATION = "showNotification"
export const SET_MESSAGE = "setMessage"
export const SET_MEMBERS = "setMembers"
export const SET_SEARCH_TERM = "setSearchTerm"
export const ADD_MEMBER = "addMember"
